import React from "react";
import { FaPhoneAlt, FaEnvelope } from "react-icons/fa";
import "../styles/topbar.css";

const PHONE_DISPLAY = "+91 94800 85001";
const PHONE_TEL = "+919480085001";
const EMAIL = "gitiharihara@gmail.com";

const TopBar = () => (
  <div className="top-bar">
    <div className="container top-bar-inner">
      <span className="top-bar-badge">Government ITI Harihara</span>
      <div className="top-bar-contacts">
        <a href={`tel:${PHONE_TEL}`} className="top-bar-link">
          <FaPhoneAlt aria-hidden />
          {PHONE_DISPLAY}
        </a>
        <a href={`mailto:${EMAIL}`} className="top-bar-link">
          <FaEnvelope aria-hidden />
          {EMAIL}
        </a>
      </div>
    </div>
  </div>
);

export default TopBar;
